import { hoc } from '#packages/util';
import * as stateManagement from '#packages/stateManagement';

const mapDispatchToProps = {
  openHelpCenter: stateManagement.panels.actions.openHelpCenter,
};

export default hoc.connect(hoc.STORES.EDITOR_API, null, mapDispatchToProps);
